/// <reference path="../../typings/browser.d.ts" />

namespace Application.Models {
    'use strict';
    import Utils = Common.Utils;
    
    export interface INetwork extends ITopologyElement {
        name: string;
        ipAddress: string;
        subnetMask: string;
        href: string;
        id: number;
        type: NetworkType;
        isInternet: () => boolean;
        getDisplayLabel: () => string;
        isSon: () => boolean;
        canWrite?: boolean;
        vnos: Models.Vno[];
        isShared?: boolean;
    }
    
    export class Network implements INetwork {
        public name: string;
        public ipAddress: string;
        public subnetMask: string;
        public x: number;
        public y: number;
        public href: string;
        public id: number;
        public health: IDataNodeHealth;
        public type: NetworkType;
        public canWrite: boolean;
        public vnos: Models.Vno[];
        public isShared?: boolean;

        public static Empty(): Network {
            return new Network();
        }

        constructor() {
            // empty constructor
            this.href = '';
            this.ipAddress = '';
            this.subnetMask = '';
            this.name = '';
            this.id = undefined;
            this.health = undefined;
            this.type = NetworkType.DEFAULT;
            this.canWrite = false;
            this.vnos = [];
            this.isShared = undefined;
        }

        public class(): TopologyElementType {
            return !this.isSon() ? TopologyElementType.Network : TopologyElementType.SonNetwork;
        }

        public isInternet(): boolean {
            return this.type === NetworkType.INTERNET;
        }

        public getDisplayLabel(): string {
            return this.name;
        }

        public getDisplayLabelWithIpMask(): string {
            if (!this.isInternet() && !this.isSon()) {
                return this.name + "\n" + this.getCIDRNotation();
            } else {
                return this.getDisplayLabel();
            }
        }

        public getCIDRNotation(): string {
            return Common.Utils.getCIDRFromSubnetMask(this.ipAddress, this.subnetMask);
        }

        public getDisplayImage(): string {
            if (this.isInternet())
                return 'images/iconmonstr-networking-6-240.png';
            else if (this.isSon())
                return 'images/son-network.png';
            else
                return 'images/iconmonstr-cloud-2-240.png';
        }

        public isSon(): boolean {
            return this.type === NetworkType.SON;
        }

        public getVnoNames(): string {
            return this.isShared && this.vnos.length === 1 ? 'shared' : this.vnos.map((vno: Models.Vno) => (vno.name)).join(', ');
        }

        public matchesSearch(search: string): boolean {
            const searchText: string = this.type + this.subnetMask + this.name + this.id + this.getVnoNames();
            const regExp: RegExp = new RegExp(search, "ig");
            return regExp.test( searchText );
        }
    }

    export class NetworkType {
        public static INTERNET: string = "INTERNET";
        public static SON: string = "SON";
        public static DEFAULT: string = "DEFAULT";
    }
}
